/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomerConfigClerk } from './CustomerConfigClerk';
import {
    CustomerConfigClerkFromJSON,
    CustomerConfigClerkFromJSONTyped,
    CustomerConfigClerkToJSON,
} from './CustomerConfigClerk';
import type { EmailBranding } from './EmailBranding';
import {
    EmailBrandingFromJSON,
    EmailBrandingFromJSONTyped,
    EmailBrandingToJSON,
} from './EmailBranding';
import type { CustomerConfigPlayslips } from './CustomerConfigPlayslips';
import {
    CustomerConfigPlayslipsFromJSON,
    CustomerConfigPlayslipsFromJSONTyped,
    CustomerConfigPlayslipsToJSON,
} from './CustomerConfigPlayslips';

/**
 * 
 * @export
 * @interface PlayerDataCustomerConfig
 */
export interface PlayerDataCustomerConfig {
    /**
     * 
     * @type {CustomerConfigPlayslips}
     * @memberof PlayerDataCustomerConfig
     */
    playslips?: CustomerConfigPlayslips | null;
    /**
     * 
     * @type {EmailBranding}
     * @memberof PlayerDataCustomerConfig
     */
    emailBranding?: EmailBranding | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlayerDataCustomerConfig
     */
    pamEmailsEnabled?: boolean | null;
    /**
     * 
     * @type {CustomerConfigClerk}
     * @memberof PlayerDataCustomerConfig
     */
    clerk?: CustomerConfigClerk | null;
    /**
     * 
     * @type {string}
     * @memberof PlayerDataCustomerConfig
     */
    firebaseServiceAccountJson?: string | null;
    /**
     * Whether an already-saved scan carries the GO_TO_WALLET cta. Off for customers whose released scanner builds
     * predate that enum value and fail their whole scan-response decode on it.
     * @type {boolean}
     * @memberof PlayerDataCustomerConfig
     */
    scannerGoToWalletCtaEnabled?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof PlayerDataCustomerConfig
     */
    ticketWalletVisibilityDays?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlayerDataCustomerConfig
     */
    ticketWalletEnabled?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlayerDataCustomerConfig
     */
    allowDeviceTicketScans?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof PlayerDataCustomerConfig
     */
    maxTicketsPerReservation?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlayerDataCustomerConfig
     */
    claimFormEnabled?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PlayerDataCustomerConfig
     */
    claimsReservationHostUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlayerDataCustomerConfig
     */
    appHostName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlayerDataCustomerConfig
     */
    smsSender?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlayerDataCustomerConfig
     */
    emailSender?: string | null;
}

/**
 * Check if a given object implements the PlayerDataCustomerConfig interface.
 */
export function instanceOfPlayerDataCustomerConfig(value: object): value is PlayerDataCustomerConfig {
    return true;
}

export function PlayerDataCustomerConfigFromJSON(json: any): PlayerDataCustomerConfig {
    return PlayerDataCustomerConfigFromJSONTyped(json, false);
}

export function PlayerDataCustomerConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayerDataCustomerConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'playslips': json['playslips'] == null ? undefined : CustomerConfigPlayslipsFromJSON(json['playslips']),
        'emailBranding': json['emailBranding'] == null ? undefined : EmailBrandingFromJSON(json['emailBranding']),
        'pamEmailsEnabled': json['pamEmailsEnabled'] == null ? undefined : json['pamEmailsEnabled'],
        'clerk': json['clerk'] == null ? undefined : CustomerConfigClerkFromJSON(json['clerk']),
        'firebaseServiceAccountJson': json['firebaseServiceAccountJson'] == null ? undefined : json['firebaseServiceAccountJson'],
        'scannerGoToWalletCtaEnabled': json['scannerGoToWalletCtaEnabled'] == null ? undefined : json['scannerGoToWalletCtaEnabled'],
        'ticketWalletVisibilityDays': json['ticketWalletVisibilityDays'] == null ? undefined : json['ticketWalletVisibilityDays'],
        'ticketWalletEnabled': json['ticketWalletEnabled'] == null ? undefined : json['ticketWalletEnabled'],
        'allowDeviceTicketScans': json['allowDeviceTicketScans'] == null ? undefined : json['allowDeviceTicketScans'],
        'maxTicketsPerReservation': json['maxTicketsPerReservation'] == null ? undefined : json['maxTicketsPerReservation'],
        'claimFormEnabled': json['claimFormEnabled'] == null ? undefined : json['claimFormEnabled'],
        'claimsReservationHostUrl': json['claimsReservationHostUrl'] == null ? undefined : json['claimsReservationHostUrl'],
        'appHostName': json['appHostName'] == null ? undefined : json['appHostName'],
        'smsSender': json['smsSender'] == null ? undefined : json['smsSender'],
        'emailSender': json['emailSender'] == null ? undefined : json['emailSender'],
    };
}

export function PlayerDataCustomerConfigToJSON(value?: PlayerDataCustomerConfig | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'playslips': CustomerConfigPlayslipsToJSON(value['playslips']),
        'emailBranding': EmailBrandingToJSON(value['emailBranding']),
        'pamEmailsEnabled': value['pamEmailsEnabled'],
        'clerk': CustomerConfigClerkToJSON(value['clerk']),
        'firebaseServiceAccountJson': value['firebaseServiceAccountJson'],
        'scannerGoToWalletCtaEnabled': value['scannerGoToWalletCtaEnabled'],
        'ticketWalletVisibilityDays': value['ticketWalletVisibilityDays'],
        'ticketWalletEnabled': value['ticketWalletEnabled'],
        'allowDeviceTicketScans': value['allowDeviceTicketScans'],
        'maxTicketsPerReservation': value['maxTicketsPerReservation'],
        'claimFormEnabled': value['claimFormEnabled'],
        'claimsReservationHostUrl': value['claimsReservationHostUrl'],
        'appHostName': value['appHostName'],
        'smsSender': value['smsSender'],
        'emailSender': value['emailSender'],
    };
}

